import "./App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import KarmaCalculator from "./pages/KarmaCalculator";
import AdminPanel from "./pages/AdminPanel";
import StudentLogin from "./pages/StudentLogin";
import PortalLogin from "./pages/PortalLogin";
import LanguageSwitcher from "./components/LanguageSwitcher";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageSwitcher position="top-left" />
        <Routes>
          <Route path="/" element={<KarmaCalculator />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/dashboard" element={<AdminPanel mode="user" />} />
          <Route path="/portal" element={<PortalLogin />} />
          <Route path="/student/login" element={<StudentLogin />} />
          <Route path="/student" element={<KarmaCalculator pageMode="student" />} />
          <Route path="/u/:slug" element={<KarmaCalculator pageMode="user" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
